import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface Props {
  name: string;
  isActive?: boolean;
  children: React.ReactNode;
  onToggle: (checked: boolean) => void;
}

const FilterCheckbox: React.FC<Props> = ({
  isActive,
  onToggle,
  name,
  children,
  ...rest
}) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          checked={isActive}
          onChange={(_: unknown, checked: boolean) => onToggle(checked)}
          value={name}
          data-test-locator="FilterCheckbox"
        />
      }
      label={children}
      {...rest}
    />
  </div>
);

export default FilterCheckbox;
